export default {
  path: 'shop',
  name: 'shop',
};
